import { AnyAction } from "redux";
import {
  REQUEST_FETCH_SYSTEM,
  REQUEST_FETCH_SYSTEM_ERROR,
  REQUEST_FETCH_SYSTEM_SUCCESS,
} from "redux/actions/general/system";

const defaultState = {
  data: [],
  error: null,
  loading: false,
};

export default (state = defaultState, action: AnyAction) => {
  switch (action.type) {
    case REQUEST_FETCH_SYSTEM:
      return {
        ...state,
        loading: true,
      };
    case REQUEST_FETCH_SYSTEM_SUCCESS:
      return {
        data: action.system,
        error: null,
        loading: false,
      };
    case REQUEST_FETCH_SYSTEM_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
};
